(function ($) {
    "use strict";

    $(function () {
        var $body = $('body');

        if (!$body.hasClass("MicrositePage2022")) {
            return;
        }
        var $micrositesPage = $body.find('#MicroSites-pagepilling');
        if ($micrositesPage.length) {
            var makePagepiling = !$('html').hasClass('no-pagepiling');

            var $nav = $('.mainNav'),
                anchors = [],
                tooltips = [],
                $floatingBtn = [];
            $nav.find('.mainNav__list--item').each(function () {
                anchors.push($(this).data('menuanchor'));
                tooltips.push($(this).find('a').text());
            });
            if (makePagepiling) {
                $micrositesPage.pagepiling({
                    sectionSelector: '#MicroSites-pagepilling > section',
                    anchors: anchors,
                    menu: '.mainNav__list',
                    navigation: {
                        'position': 'right'
                    },
                    scrollingSpeed: 100,
                    touchSensitivity: 5,
                    normalScrollElements: "iframe",
                    normalScrollElementTouchThreshold: 2,
                    onLeave: function (index, nextIndex) {
                        // Main navigation states
                        if (nextIndex > index)
                            $nav.removeClass('mainNav--pinned').addClass('mainNav--unpinned');
                        else
                            $nav.removeClass('mainNav--unpinned').addClass('mainNav--pinned');

                        if (nextIndex > 1)
                            $nav.addClass('mainNav--scrolling');
                        else
                            $nav.removeClass('mainNav--scrolling mainNav--pinned');

                        // Floating button for download whitepaper
                        if ($floatingBtn.length) {
                            setFloatingPosition($floatingBtn[1]);

                            // Current section is the one floatingBtn is targeting to
                            if ($floatingBtn[1].attr('href') === '#' + $nav.find('.mainNav__list--item').eq(nextIndex - 1).data('menuanchor')) {
                                $floatingBtn[1].addClass('floatingBtn--hidden');
                            }
                            // Current section is the first one
                            else if (nextIndex === 1) {
                                $floatingBtn[1].removeClass('floatingBtn--hidden floatingBtn--floating-right');
                                $floatingBtn[1].addClass('floatingBtn--initial');
                                setInitialPosition($floatingBtn[1]);
                            }
                            else {
                                $floatingBtn[1].removeClass('floatingBtn--initial floatingBtn--hidden');
                                $floatingBtn[1].addClass('floatingBtn--floating-right');
                            }
                        }

                    },
                    afterRender: function () {
                        initMicrosite($body, $nav, $floatingBtn, makePagepiling);

                        $nav.find('.mainNav__list--item a').click(function () {
                            $body.find($(this).attr('href')).scrollTop(0);
                        });

                        $body.find('.section').each(function (index) {
                            if ($(this).hasClass('section--long')) {
                                $body.find('#pp-nav li').eq(index).addClass('long');
                            }

                            // Remove animation from non-hero section if mobile
                            if (window.innerWidth < 768) {
                                $(this).find('.beforeLoad').removeClass('beforeLoad');
                            }

                        });

                        $body.find('#pp-nav li a').each(function (index) {
                            var $this = $(this);
                            $this.append('<button type="button" data-href="#' + anchors[index] + '" class="tieto-tooltip"><div>' + tooltips[index] + '</div></button>');
                            $this.hover(function () {
                                $this.toggleClass('tieto-tooltip--show');
                            });
                            $this.click(function () {
                                $body.find($this.attr('href')).scrollTop(0);
                            });
                        });

                        var lastScroll = 0;
                        $('.section--long').scroll(function (e) {
                            var newScroll = $(e.target).scrollTop();
                            if (newScroll < lastScroll) {
                                $nav.addClass('mainNav--pinned').removeClass('mainNav--unpinned');
                            }
                            else {
                                $nav.addClass('mainNav--unpinned').removeClass('mainNav--pinned');
                            }
                            lastScroll = newScroll;
                        });
                    },
                    afterLoad: function (anchorLink, index) {
                        var $currentSection = $body.find('section[id=' + anchorLink + ']')
                        $currentSection.find('.beforeLoad').removeClass('beforeLoad');
                        $body.find('.mainNav__section-name').html($body.find('.mainNav__list--item.active').text());

                        initFullBackgroundImage($currentSection.find('.full-background-image').not('.lazyloaded'));
                    }
                });
            }
            // Pagepiling is off
            else {
                initMicrosite($body, $nav, $floatingBtn, makePagepiling);

                var $fullBackgroundImages = $body.find('.full-background-image').not('.lazyloaded');

                $fullBackgroundImages.each(function () {
                    initFullBackgroundImage($(this));
                });

                var $firstSection = $body.find("section").eq(0);

                // Hide floating button on target section
                if ($floatingBtn.length) {
                    if ($floatingBtn[1].attr('href').startsWith('#')) {
                        var $floatingBtnTargetSection = $($floatingBtn[1].attr('href'));
                    }
                }

                var navHeight = $('.mainNav').outerHeight() + 1;
                highlightSection(navHeight, $(window).scrollTop());

                $(window).scroll(function () {
                    var scroll = $(window).scrollTop();

                    highlightSection(navHeight, scroll);

                    // scroll down
                    if (scroll === 0) {
                        $nav.removeClass('mainNav--unpinned');
                    }
                    else if (scroll <= $firstSection.outerHeight() - navHeight - 20)
                        $nav.removeClass('mainNav--pinned').addClass('mainNav--unpinned');
                    else
                        $nav.removeClass('mainNav--unpinned').addClass('mainNav--pinned');

                    // page is scrolled
                    if (scroll > 0)
                        $nav.addClass('mainNav--scrolling');
                    else
                        $nav.removeClass('mainNav--scrolling mainNav--pinned');

                    // Floating button for download whitepaper
                    if ($floatingBtn.length) {
                        // Hide floating button on target section
                        if ($floatingBtnTargetSection && $floatingBtnTargetSection.length &&
                            scroll > $floatingBtnTargetSection.offset().top - $floatingBtnTargetSection.outerHeight() / 2 &&
                            scroll > $firstSection.outerHeight() / 2 &&
                            scroll < $floatingBtnTargetSection.offset().top + $floatingBtnTargetSection.outerHeight()) {
                            $floatingBtn[1].addClass('floatingBtn--hidden');
                        }
                        else {
                            $floatingBtn[1].removeClass('floatingBtn--hidden');
                        }

                        // Set initial vs. floating position (pagepiling OFF)
                        if (scroll <= 20) {
                            $floatingBtn[1].removeClass('floatingBtn--floating-right');
                            $floatingBtn[1].addClass('floatingBtn--initial');
                            setInitialPosition($floatingBtn[1]);
                        }
                        else {
                            $floatingBtn[1].removeClass('floatingBtn--initial');
                            $floatingBtn[1].addClass('floatingBtn--floating-right');
                            setFloatingPosition($floatingBtn[1]);
                        }
                    }
                });
            }
        }

        $body.find('.mainNav__toggleNav').click(function () {
            $(this).toggleClass('toggled');
            $body.find('.mainNav').toggleClass('mainNav--nav-open');
            $body.toggleClass('pageOverlay');
        });

        $body.click(function (e) {
            if (!$(e.target).hasClass('mainNav__list') && !$(e.target).hasClass('mainNav__toggleNav')) {
                $body.find('.mainNav__toggleNav').removeClass('toggled');
                $body.find('.mainNav').removeClass('mainNav--nav-open');
                $body.removeClass('pageOverlay');
            }
        });
    });

    function setFloatingPosition($btn) {
        var ww = window.innerWidth;

        var btnWidth = parseInt($(".animation .floatingBtn").outerWidth() + 20);
        var btnTop = ww < 768 ? parseInt($btn.outerHeight() + 50) : parseInt($btn.outerHeight() + 20);

        $btn.css({
            left: 'calc(100vw - ' + btnWidth + 'px)',
            top: 'calc(100vh - ' + btnTop + 'px)',
            transform: 'none'
        });
    }

    function calculateInitialPosition($floatingBtn) {
        var p = $(".animation .floatingBtn");
        var btnLeft = (p.offset().left) + "px";
        var btnTop = $('body').find('.floatingBtn').eq(0).offset().top + "px";

        $floatingBtn.attr("data-left", btnLeft);
        $floatingBtn.attr("data-top", btnTop);
    }

    function setInitialPosition($btn) {
        // Get
        var p = $(".animation .floatingBtn");
        var btnLeft = p.attr("data-left");
        var btnTop = p.attr("data-top");

        // Set
        $btn.css({
            left: btnLeft,
            top: btnTop
        });
    }

    function highlightSection(navHeight, scroll) {
        // Main navigation states
        $('.mainNav li a').each(function () {
            var sectionLink = $(this);
            // capture the height of the navbar

            var section = $(sectionLink.attr('href'));

            // subtract the navbar height from the top of the section
            if (section.position() != undefined && section.position().top - navHeight <= scroll && sectionLink.offset().top + section.height() > scroll) {
                $('.mainNav li').removeClass('active');
                sectionLink.parent().addClass('active');
            } else {
                sectionLink.parent().removeClass('active');
            }
        });
    }

    // Loading of Showstopper elements
    function initFullBackgroundImage(fullBackgroundImage) {
        var prevDevice = fullBackgroundImage.attr('data-device');
        var ww = window.innerWidth,
            src;
        if (ww < 768) {
            src = fullBackgroundImage.attr('data-src-mobile');
            fullBackgroundImage.attr('data-device', 'mobile');
        }
        else if (ww < 992) {
            src = fullBackgroundImage.attr('data-src-tablet');
            fullBackgroundImage.attr('data-device', 'tablet');
        }
        else {
            src = fullBackgroundImage.attr('data-src-desktop');
            fullBackgroundImage.attr('data-device', 'desktop');
        }

        if (
            (fullBackgroundImage.hasClass('lazyloaded') || fullBackgroundImage.attr('data-device') !== prevDevice)
        ) {
            fullBackgroundImage.removeClass('lazyloaded');
            var downloadingImage = new Image();
            downloadingImage.onload = function () {
                fullBackgroundImage.addClass('lazyloaded').css('background-image', 'url(' + this.src + ')');
            };
            downloadingImage.src = src;
        }
    }

    function initMicrosite($body, $nav, $floatingBtn, makePagepiling) {
        //Carousel
        var $carousel = $body.find('.microsite-hero-carousel');
        var $figures = $carousel.siblings('.microsite-hero-carousel__figures').find('>div');
        $figures.each(function () {
            var $this = $(this).find('.figure-info');
            $this.eq(0).addClass('active');
        });
        if ($carousel.length) {
            $carousel.slick({
                autoplay: true,
                dots: true,
                autoplaySpeed: 5000,
                fade: true,
                cssEase: 'linear',
                prevArrow: '<div class="slick-prev"><svg class="icon icon_arrowDown"><use xlink:href="#icon_arrowDown"></use></svg></div>',
                nextArrow: '<div class="slick-next"><svg class="icon icon_arrowDown"><use xlink:href="#icon_arrowDown"></use></svg></div>'
            }).on('beforeChange', function (event, slick, currentSlide, nextSlide) {
                $figures.each(function () {
                    var $this = $(this).find('.figure-info');
                    $this.removeClass('active');
                    $this.eq(nextSlide).addClass('active');
                });
            });
        }

        // Fire animation of content on section
        var $firstSection = $body.find('.section').eq(0);
        var firstAnchor = $firstSection.attr('id');
        if (!window.location.hash || window.location.hash === '#' + firstAnchor) {
            $body.find('section[id=' + firstAnchor + ']').find('.beforeLoad').removeClass('beforeLoad');
        }

        // Clone DownloadBtn, set initial fixed position and hide the initial btn
        if ($body.find('.floatingBtn').length) {
            $floatingBtn.push($body.find('.floatingBtn'));
            $floatingBtn.push($floatingBtn[0].clone().appendTo($body));
            calculateInitialPosition($floatingBtn[0]);
            $floatingBtn[0].addClass('floatingBtn--hidden');
            $floatingBtn[1].addClass('floatingBtn--initial');

            var scroll = $(window).scrollTop();

            if (scroll <= 20) {
                setInitialPosition($floatingBtn[1]);
            }
            else {
                setFloatingPosition($floatingBtn[1]);
            }
        }

        var $fullBackgroundImages = $('.full-background-image');
        $(window).on('resize', function () {
            $fullBackgroundImages.each(function () {
                initFullBackgroundImage($(this));
            });

            // Reposition of floating btn
            setTimeout(function () {
                if ($floatingBtn.length) {
                    var scroll = $(window).scrollTop();

                    // Check if pagepiling is ON
                    if ($("#pp-nav").length) {
                        if (!window.location.hash || window.location.hash === '#' + firstAnchor) {
                            calculateInitialPosition($floatingBtn[0]);
                            setInitialPosition($floatingBtn[1]);
                        }
                        else {
                            setFloatingPosition($floatingBtn[1]);
                        }
                    }
                    else {
                        // Pagepiling is OFF
                        calculateInitialPosition($floatingBtn[0]);

                        if (scroll <= 20) {
                            setInitialPosition($floatingBtn[1]);
                        }
                        else {
                            setFloatingPosition($floatingBtn[1]);
                        }
                    }
                }
            }, 500);
        });
        $body.find('.heroArrowDown').click(function () {
            if (makePagepiling)
                $.fn.pagepiling.moveSectionDown();
            else {
                $('html,body').animate({
                    scrollTop: $firstSection.outerHeight()
                },
                    'slow');
            }

        });

        $nav.find('.tieto-logo').click(function () {
            if (makePagepiling)
                $.fn.pagepiling.moveTo(1);
            else
                $(window).scrollTop(0);
        });

        // Remove padding from the section row, add background color
        $body.find('.msite-two-column-connected').each(function () {
            if ($(this).hasClass('no-padding') && $(this).parent().hasClass('continuous-section__row')) {
                $(this).parent().addClass('no-padding');

            }
            if ($(this).hasClass('bg-dark-blue') && $(this).parent().hasClass('continuous-section__row')) {
                $(this).parent().addClass('bg-dark-blue');
                $(this).parent().removeClass('no-padding').css("padding-bottom", "0px");
                $('.microsite-continuous-section-block .msite-two-column').css("padding-top", "50px");
                $('.microsite-continuous-section-block .msite-two-column').css("padding-bottom", "50px");
            }
            if ($(this).hasClass('bg-blue') && $(this).parent().hasClass('continuous-section__row')) {
                $(this).parent().addClass('bg-blue');
            }
            if ($(this).hasClass('bg-grey') && $(this).parent().hasClass('continuous-section__row')) {
                $(this).parent().addClass('bg-grey');
            }
            if ($(this).hasClass('bg-toreabay-blue') && $(this).parent().hasClass('continuous-section__row')) {
                $(this).parent().addClass('bg-toreabay-blue');
            }
        });

    }
})(jQuery);

//Lazyload must be run after all files are loaded, because microsite.js is loaded before main.js and all other js files
window.addEventListener('load', function () {
    $('.lazyload').lazyload({
        container: $("section.section"),
        threshold: window.innerHeight
    });

    $('.imageGalleryBlock').each(function () {
        $(this).find('a.js-gallery').featherlightGallery({
            previousIcon: '<svg class="icon icon-arrowBreadcrumb"><use xlink:href="#icon-arrowBreadcrumb"></use></svg>',
            nextIcon: '<svg class="icon icon-arrowBreadcrumb"><use xlink:href="#icon-arrowBreadcrumb"></use></svg>',
            root: $('body')
        });
    });
});

